import type { ReactNode } from "react";

export type BadgeTone = "neutral" | "blue" | "indigo" | "green" | "purple" | "red" | "amber";

const SOFT: Record<BadgeTone, string> = {
  neutral: "border-gray-200 bg-gray-50 text-gray-600",
  blue: "border-blue-100 bg-blue-50 text-blue-700",
  indigo: "border-indigo-100 bg-indigo-50 text-indigo-700",
  green: "border-green-100 bg-green-50 text-green-700",
  purple: "border-purple-100 bg-purple-50 text-purple-700",
  red: "border-red-100 bg-red-50 text-red-700",
  amber: "border-amber-100 bg-amber-50 text-amber-700",
};

const SOLID: Record<BadgeTone, string> = {
  neutral: "bg-gray-100 text-gray-600",
  blue: "bg-blue-100 text-blue-700",
  indigo: "bg-indigo-100 text-indigo-700",
  green: "bg-green-100 text-green-700",
  purple: "bg-purple-100 text-purple-700",
  red: "bg-red-100 text-red-600",
  amber: "bg-amber-100 text-amber-700",
};

interface BadgeProps {
  children: ReactNode;
  tone?: BadgeTone;
  variant?: "soft" | "solid";
  shape?: "pill" | "rounded";
  className?: string;
}

export default function Badge({ children, tone = "neutral", variant = "soft", shape = "pill", className = "" }: BadgeProps) {
  const radius = shape === "pill" ? "rounded-full" : "rounded-md";
  const border = variant === "soft" ? "border" : "";
  const tones = variant === "soft" ? SOFT[tone] : SOLID[tone];
  return (
    <span className={`inline-flex min-h-6 items-center gap-1 whitespace-nowrap px-2.5 py-0.5 text-xs font-medium leading-none ${radius} ${border} ${tones} ${className}`}>
      {children}
    </span>
  );
}
